// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Step 3: Fixed asset rollforward step. A thin wrapper over RollforwardReviewStep supplying the
 * fixed-asset waterfall chart and copy; the shared component owns the review, auto-advance, and
 * flourish behavior. Amounts are never netted across currencies.
 */
import {
  CloseRunCurrencyBucket,
  JournalEntryWithReviewState,
} from '@/accounting/api/types';
import { RollforwardReviewStep } from '@/accounting/components/rollforward-review-step';
import { AssetWaterfallChart } from '@/report/components/asset-waterfall-chart';

interface Props {
  entries: JournalEntryWithReviewState[];
  buckets: CloseRunCurrencyBucket[];
  onEntriesChange: (entries: JournalEntryWithReviewState[]) => void;
  onNext: () => void;
  onBack: () => void;
}

export function FixedAssetRollforwardStep(props: Props) {
  return (
    <RollforwardReviewStep
      entries={props.entries}
      buckets={props.buckets}
      onEntriesChange={props.onEntriesChange}
      onNext={props.onNext}
      onBack={props.onBack}
      idNamespace="fixed-asset-rollforward-section"
      chartTitle="Fixed asset rollforward"
      chartSubheader="Review fixed asset balance changes"
      journalSubheader="Review and export journal entries for fixed asset transactions"
      emptyMessage="No fixed asset rollforward data for this period"
      continueLabel="Continue to prior period adjustments"
      renderChart={(bucket, metricType) => (
        <AssetWaterfallChart
          data={bucket.fixedAssetRollforward}
          metricType={metricType}
          currencyCode={bucket.currency}
        />
      )}
    />
  );
}
